import { Token } from "@/lib/classes/BaseNetwork";
import { CoinGeckoMarketDataResponse } from "@/lib/helpers/coingecko";

export const mapMarketData = <T extends CoinGeckoMarketDataResponse | Token>(
  data: T[],
): T[] => {
  return data.map(token => {
    switch (token.id) {
      case "polygon-ecosystem-token":
      case "matic-network":
        return {
          ...token,
          id: "polygon-ecosystem-token",
          name: "Polygon",
          symbol: "POL",
        };

      // WETH
      case "polygon-pos-bridged-weth-polygon-pos":
      case "avalanche-bridged-weth-avalanche":
        return {
          ...token,
          id: "weth",
          name: "Wrapped Ethereum",
          symbol: "WETH",
        };

      // WBTC
      case "arbitrum-bridged-wbtc-arbitrum-one":
      case "polygon-bridged-wbtc-polygon-pos":
      case "avalanche-old-bridged-wbtc-avalanche":
        return {
          ...token,
          id: "wrapped-bitcoin",
          name: "Wrapped Bitcoin",
          symbol: "WBTC",
        };

      // USDT
      case "polygon-bridged-usdt-polygon":
      case "binance-bridged-usdt-bnb-smart-chain":
      case "tether-avalanche-bridged-usdt-e":
        return { ...token, name: "Tether", symbol: "USDT" };

      // USDC
      case "bridged-usdc-polygon-pos-bridge":
      case "binance-bridged-usdc-bnb-smart-chain":
      case "usd-coin-avalanche-bridged-usdc-e":
        return { ...token, id: "tether", name: "USDC", symbol: "USDC" };

      // DAI
      case "polygon-pos-bridged-dai-polygon-pos":
      case "avalanche-bridged-dai-avalanche":
        return { ...token, id: "dai", name: "DAI", symbol: "DAI" };

      case "binance-smart-chain":
        return { ...token, symbol: "BNB" };
      case "avalanche-2":
        return { ...token, name: "Avalanche", symbol: "AVAX" };
      case "ripple":
        return { ...token, symbol: "XRP" };
      case "bitcoin-cash":
        return { ...token, symbol: "BCH" };
      case "dogecoin":
        return { ...token, symbol: "DOGE" };
      default:
        return token;
    }
  });
};

const moralisSymbolMapping: Record<string, string> = {
  "BSC-USD": "USDT",
};

export const mapSymbol = (symbol: string) => {
  return moralisSymbolMapping[symbol] || symbol;
};
